import { createModuleDescriptor } from '../../redux/module-descriptor';
import * as helpers from './helpers';

export default createModuleDescriptor('rental', {
  helpers,
});
